<template>
  <NuxtLayout v-if="loading" name="loading" />
  <NuxtLayout v-else :name="layoutName">
    <NuxtPage />
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { Page } from "./types/enum";

const route = useRoute();
const loading = ref(true);

onMounted(() => {
  loading.value = false;
});

const layoutName = computed(() => {
  if (
    route.fullPath.startsWith(Page.RVSRegister) ||
    route.fullPath.startsWith(Page.Print)
  ) {
    return "rvs";
  }
  if (route.fullPath.startsWith(Page.UkoPrint)) {
    return "uko";
  }
  return "default";
});
</script>

<style lang="scss">
html {
  overflow: hidden;
}

.v-application__wrap {
  min-height: 100% !important;
  height: 100% !important;
}
</style>
